import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';

const FormatPrice = injectIntl(({ value, currency, children, ...customProps }) => {
  const currencyProps = currency ? { currency, style: 'currency' } : { format: 'price' };

  return (
    <FormattedNumber
      value={Number(value || 0) || 0}
      currencyDisplay={'symbol'}
      minimumIntegerDigits={1}
      minimumFractionDigits={2}
      maximumFractionDigits={2}
      useGrouping={true}
      children={children}
      {...currencyProps}
      {...customProps}
    />
  );
});

FormatPrice.propTypes = {
  intl: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FormatPrice;
